import { z } from "zod"
import { validateEventHasAction, WorkflowNodeSchema } from "../campaigns/dtos"
import { Errors } from "../errors"
import { PaginationSchema } from "../shared/pagination_dtos"

export const GetWorkflowSchema = z.object({
  id: z.string().transform(BigInt),
})

export const GetWorkflowsSchema = PaginationSchema.partial().extend({
  // present => that campaign's workflows; absent => global workflows
  campaignId: z.string().transform(BigInt).optional(),
})

export const CreateWorkflowSchema = z.object({
  name: z.string().nullish(),
  // present => scope the workflow to this campaign; absent => global
  campaignId: z.string().transform(BigInt).optional(),
})

export const UpdateWorkflowSchema = z
  .object({
    name: z.string().nullish(),
    isEnabled: z.boolean().nullish(),
    nodes: z.array(WorkflowNodeSchema).nullish(),
  })
  .refine(validateEventHasAction, {
    path: ["nodes"],
    message: Errors.CAMPAIGN_EVENT_WITHOUT_ACTION,
  })

// Portable workflow shape shared by export, import and duplicate: name + node tree, no ids/scope.
// Export output equals import input, which keeps the round-trip clean.
export const WorkflowBlueprintSchema = z
  .object({
    version: z.literal("1"),
    name: z.string().nullish(),
    nodes: z.array(WorkflowNodeSchema),
  })
  .refine(validateEventHasAction, {
    path: ["nodes"],
    message: Errors.CAMPAIGN_EVENT_WITHOUT_ACTION,
  })

export const DuplicateWorkflowSchema = z.object({
  name: z.string().nullish(),
  // present => scope the copy to this campaign; absent/null => global
  campaignId: z.string().transform(BigInt).nullish(),
})

export const ImportWorkflowSchema = z.object({
  // The signed .permutflow envelope, verified and decoded server-side. Import returns a preview for
  // the canvas; it never persists, so no campaign scope is needed here.
  file: z.string(),
})
